// resources/js/widgets.ts

/// <reference types="vite/client" />
import { registerWidget } from '@/core/registry';
import { vueModule } from '@/adapters/vue-module';

type SFCImporter = () => Promise<any>;
const raw = import.meta.glob('./widgets/*.vue') as Record<string, SFCImporter>;

// Extract the widget key from the SFC path
// E.g. './widgets/ExampleWidget.vue' → 'ExampleWidget'
function toKey(p: string) {
    const m = p.match(/\/([^/]+)\.vue$/);
    return m ? m[1] : p;
}

// Register each SFC path as a widget key → factory(ComponentModule)
for (const [path, importer] of Object.entries(raw)) {
    const key = toKey(path);
    registerWidget(key, async () => vueModule(() => importer()));
}

